import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14284632"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "well well-sm" }
const _hoisted_4 = { class: "panel" }
const _hoisted_5 = { class: "q-pa-md" }
const _hoisted_6 = { style: {"display":"flex","align-items":"center","margin-bottom":"15px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Servicii de transport - Actiune solicitata", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "absolute-right q-pa-md" }
const _hoisted_10 = { style: {"display":"flex","align-items":"start"} }
const _hoisted_11 = { style: {"width":"100%","display":"flex","flex-direction":"row"} }
const _hoisted_12 = { style: {"display":"flex","flex-direction":"column","width":"100%"} }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 form__label" }, "Id", -1))
const _hoisted_15 = { class: "col-9 form__label__black" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 form__label" }, "Numar", -1))
const _hoisted_18 = { class: "col-9 form__label__black" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 form__label" }, "Data", -1))
const _hoisted_21 = { class: "col-9 form__label__black" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 form__label" }, "Nume", -1))
const _hoisted_24 = { class: "col-9 form__label__black" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 form__label" }, "Solicitant", -1))
const _hoisted_27 = { class: "col-9 form__label__black" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 form__label" }, "Adresa", -1))
const _hoisted_30 = { class: "col-9 form__label__black" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 form__label" }, "Stare", -1))
const _hoisted_33 = { class: "col-9 form__label__black" }
const _hoisted_34 = {
  key: 0,
  clas: "row",
  style: {"margin-top":"5px","margin-bottom":"15px"}
}
const _hoisted_35 = {
  key: 1,
  id: "iframe_preview_scan",
  type: "application/pdf",
  width: "100%",
  height: "100%",
  style: {"width":"100%","height":"calc(100vh - 70px)","overflow":"auto","border":"none"}
}
const _hoisted_36 = {
  key: 2,
  id: "iframe_preview_scan",
  width: "100%",
  height: "100%",
  style: {"width":"100%","height":"calc(100vh - 70px)","overflow":"auto","border":"none","display":"block"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_TaskList = _resolveComponent("TaskList")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadingData)
      ? (_openBlock(), _createBlock(_component_q_spinner_gears, {
          key: 0,
          color: "primary",
          size: "4em",
          class: "absolute-center"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_q_form, { ref: "myForm" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", {
                        class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  })
                      }, _hoisted_8, 2),
                      _createElementVNode("div", _hoisted_9, [
                        (_ctx.documenteServiciiDeTransport.appid != 0 && _ctx.documenteServiciiDeTransport.stare != 'cancellation')
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 0,
                              label: "Vizualizeaza AST",
                              color: "brown-5",
                              icon: "file_copy",
                              onClick: _ctx.onPreviewCerere,
                              style: {"margin-right":"5px"},
                              size: "sm"
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.documenteServiciiDeTransport.appid), 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _hoisted_17,
                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.documenteServiciiDeTransport.numar), 1)
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.displayDataRO(_ctx.documenteServiciiDeTransport.data)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.documenteServiciiDeTransport.nume), 1)
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _hoisted_26,
                            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.documenteServiciiDeTransport.solicitant), 1)
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _hoisted_29,
                            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.documenteServiciiDeTransport.adresa), 1)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _hoisted_32,
                            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.getDenStatus(_ctx.documenteServiciiDeTransport.stare)), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.documenteServiciiDeTransport.stare !== 'initiat')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createVNode(_component_TaskList, {
                          appid: _ctx.appid,
                          task: _ctx.task,
                          onState: _ctx.onState,
                          isSuccess: _ctx.isSuccess
                        }, null, 8, ["appid", "task", "onState", "isSuccess"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_q_dialog, {
            modelValue: _ctx.showPreviewFile,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showPreviewFile) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-up",
            "transition-hide": "slide-down"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { class: "bg-white" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, null, {
                    default: _withCtx(() => [
                      _createElementVNode("h5", null, _toDisplayString(_ctx.titleForPreviewForm), 1),
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      (_ctx.downloadingFile)
                        ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                            key: 0,
                            query: "",
                            "track-color": "orange",
                            color: "purple",
                            class: "q-mt-sm"
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isPDFFileType)
                        ? (_openBlock(), _createElementBlock("iframe", _hoisted_35))
                        : (_openBlock(), _createElementBlock("img", _hoisted_36))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
  ]))
}